import React from "react"
import { LoadingIcon, PlusOutlined } from "@atos6/icons"
import { Img } from "./Img"
import { CSS } from "../../ui"

type Props = {
  label?: string
  isLoading?: boolean
  preview?: string
}

export function UploaderView(props: Props) {
  return (
    <CSS
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      cursor="pointer"
      userSelect="none"
      backgroundColor="#F5F5F5"
      width={140}
      height={140}>
      {props.isLoading ? (
        <LoadingIcon style={{ fontSize: 48 }} />
      ) : (
        <UploaderBody label={props.label} preview={props.preview} />
      )}
    </CSS>
  )
}

function UploaderBody(props: Props) {
  return props.preview ? (
    <Img src={props.preview} />
  ) : (
    <>
      <div>
        <PlusOutlined />
      </div>
      <div style={{ textAlign: "center" }}>{props.label}</div>
    </>
  )
}
